import styled from "styled-components";

export const DividerContainer = styled.div`
	display: flex;
	width: 100%;
	height: 1px;
	background: #e4e4e4;
`;
